/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Carryover_LockedInputs */

const en_issue_carryover_locked = /** @type {(inputs: Issue_Carryover_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`belongs to a product already in the catalog and cannot be changed here`)
};

/**
* | output |
* | --- |
* | "belongs to a product already in the catalog and cannot be changed here" |
*
* @param {Issue_Carryover_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_carryover_locked = /** @type {((inputs?: Issue_Carryover_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Carryover_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_carryover_locked(inputs)
});